import classNames from 'classnames'

const SectionContainer = ({
  className,
  children,
  narrow = true,
  maxWidth = 'lg',
  disableGutters = false,
  fixed = false,
}) => {
  const maxWidthClasses = {
    xs: 'max-w-[444px]',
    sm: 'max-w-[600px]',
    md: 'max-w-[900px]',
    lg: 'max-w-[1200px]',
    xl: 'max-w-[1536px]',
    false: 'max-w-none',
  }

  const fixedMaxWidthClasses = {
    xs: 'max-w-0 xs:max-w-[600px]',
    sm: 'max-w-0 sm:max-w-[900px]',
    md: 'max-w-0 md:max-w-[1200px]',
    lg: 'max-w-0 lg:max-w-[1536px]',
    xl: 'max-w-0 xl:max-w-none',
  }

  const baseClasses = [
    // Material-UI Container base styles
    'w-full',
    'mx-auto',
    'box-border',
    'block',
  ]

  const gutterClasses = disableGutters ? [] : ['px-4', 'sm:px-6']

  const widthClasses =
    maxWidth !== false
      ? [fixed ? fixedMaxWidthClasses[maxWidth] : maxWidthClasses[maxWidth]]
      : [maxWidthClasses[false]]

  const customNarrowClasses = narrow
    ? [
        `${
          disableGutters ? '' : 'data-[narrow=true]:pl-4 data-[narrow=true]:pr-4'
        } data-[narrow=true]:max-w-7xl`.trim(),
        '[div[page-main-variation="website-wfs"]_&_[data-narrow=true]]:max-w-[998px]',
        disableGutters ? '' : 'md:data-[narrow=true]:pl-8 md:data-[narrow=true]:pr-8',
      ].filter(Boolean)
    : []

  return (
    <div
      className={classNames(
        ...baseClasses,
        ...gutterClasses,
        ...widthClasses,
        ...customNarrowClasses,
        className,
        'group'
      )}
      data-narrow={narrow}
      data-testid="section-container-classes"
    >
      {children}
    </div>
  )
}

export default SectionContainer
